import axios from "axios";

const API_URL = "https://mindreset.app/"

export const ContactUs = (params) => {
  let url = `${API_URL}srv/contact.php`
  return axios.post(url, params)
}